





























































import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator';
import { GetCosSectionsSectionCodeResponse } from 'ncp-api-supporter';
import { PromotionSlider } from '@/components/common/PromotionSlider';
import Cookies from 'js-cookie';
import $ from 'jquery';
import { setCookie } from '@/utils/cookieUtils';
import { addDay } from '@/utils/dateUtils';
import { commerceApi } from '@/api';
import moment from 'moment';
import { State } from 'vuex-class';
import { Mall } from 'ncp-api-supporter';

@Component({})
export default class CosPopup extends Vue {
  @State('malls', { namespace: 'mall' })
  public malls!: Mall[];

  @Prop() private sectionCode: string;
  @Ref()
  private readonly cosPopupWrapElementRef!: HTMLDivElement;
  @Ref()
  private readonly cosPopupElementRef!: HTMLDivElement;
  @Ref()
  private readonly cosPopupUlElementRef!: HTMLUListElement;
  @Ref()
  private readonly prevArrowRef!: HTMLAnchorElement;
  @Ref()
  private readonly nextArrowRef!: HTMLAnchorElement;

  private banners = [];
  private slider: PromotionSlider | null = null;
  private popupSlider: PromotionSlider | null = null;
  private cosPopup: GetCosSectionsSectionCodeResponse | null = null;
  private cosPopupIndex = 1;

  @Watch('isOpenCosPopup')
  private async changedCosPopup() {
    await this.$nextTick();

    const additional = { ...Object.fromEntries(new URLSearchParams(this.cosPopup.additionalInput).entries()) };

    if (additional.isDimmed === 'true') {
      this.cosPopupWrapElementRef.classList.add('dimmed');

      this.cosPopupElementRef.style.left = `calc(${this.cosPopup.positionLeft} - ${this.cosPopup.width / 2}px)`;
      this.cosPopupElementRef.style.top = `calc(${this.cosPopup.positionTop} - ${(this.cosPopup.height + 52) / 2}px)`;
      this.cosPopupElementRef.style.width = `${this.cosPopup.width}px`;
      this.cosPopupElementRef.style.height = `${this.cosPopup.height + 52}px`;
    } else {
      this.cosPopupWrapElementRef.style.left = `calc(${this.cosPopup.positionLeft} - ${this.cosPopup.width / 2}px)`;
      this.cosPopupWrapElementRef.style.top = `calc(${this.cosPopup.positionTop} - ${
        (this.cosPopup.height + 52) / 2
      }px)`;
      this.cosPopupWrapElementRef.style.width = `${this.cosPopup.width}px`;
      this.cosPopupWrapElementRef.style.height = `${this.cosPopup.height + 52}px`;
    }

    this.initCosPopup({
      autoplay: additional.autoplay === 'true',
      delay: additional.delay,
      infinite: additional.infinite === 'true',
    });
  }

  private afterPopupSlideChange() {
    $('#cosPopup').on('afterChange', (_, slick) => {
      // 마지막에 도달했을 때 무한 롤링이 아니고 자동 롤링인 경우 슬라이드를 1로 이동 후 재생
      if (slick.slideCount === slick.currentSlide + 1) {
        if (slick.options.autoplay && !slick.options.infinite) {
          slick.paused = true;
          slick.autoPlayClear();
          setTimeout(() => {
            slick.currentSlide = 1;
            slick.paused = false;
          }, slick.options.autoplaySpeed);
        }
      }
      this.cosPopupIndex = slick.currentSlide + 1;
    });
  }

  private initCosPopup({ autoplay = false, delay, infinite }: { autoplay?: boolean; delay?: string, infinite?: boolean }) {
    const { cosPopupUlElementRef, prevArrowRef, nextArrowRef } = this;

    this.popupSlider = new PromotionSlider({
      slideElement: cosPopupUlElementRef,
      prevArrow: prevArrowRef,
      nextArrow: nextArrowRef,
      dots: false,
      autoplay,
      autoplaySpeed: delay ? Number(delay) : 5000,
      infinite,
    });

    this.afterPopupSlideChange();
  }

  private mainModal = {
    [this.sectionCode]: { isClose: true },
  };

  private get isOpenCosPopup() {
    return !this.mainModal[this.sectionCode].isClose && this.cosPopup?.posts.length > 0;
  }

  private setBanner() {
    this.cosPopup.posts.forEach(post => {
      this.banners.push(post.postBodyText);
    });
  }

  private resetModalState() {
    Cookies.remove(this.sectionCode);
  }

  private setModalState() {
    const cookieValue = Cookies.get(this.sectionCode);
    const closedPostNos = this.parseClosedPostNos(cookieValue);
    const hasNewPost = this.cosPopup.posts.some(post => !closedPostNos.includes(post.postNo));
    this.mainModal[this.sectionCode].isClose = !!cookieValue && !hasNewPost;
  }

  private parseClosedPostNos(cookieValue: string | undefined): number[] {
    if (!cookieValue) {
      return [];
    }
    try {
      return JSON.parse(cookieValue).postNos ?? [];
    } catch {
      return [];
    }
  }

  private async fetchCosSections(): Promise<void> {
    const shopNos = this.malls.map(({ shopNo }) => shopNo).filter(Boolean);
    const { data } = await commerceApi.getCosSectionsSectionCode({
      pathParams: { sectionCode: this.sectionCode },
      params: { shopNos },
    });

    if (data.sectionType !== 'POP_UP') {
      return;
    }

    this.cosPopup = {
      ...data,
      positionTop: data.positionTop.toString().replace('_', ''),
      positionLeft: data.positionLeft.toString().replace('_', ''),
    };

    this.setBanner();
    if (data.cookieAliveDay === null) {
      this.resetModalState();
    }
    this.setModalState();
  }

  private closeModal(data) {
    // 크롬은 쿠키 만료일을 설정 시점 기준 최대 400일로 제한하므로, 400일이 사실상의 무기한 상한선이다.
    const expireDay = data.expireDate === 0 ? 400 : data.expireDate ?? 1;
    const expireDate = moment(addDay(new Date(), expireDay)).toDate();
    if (data.isSetCookie) {
      const postNos = this.cosPopup.posts.map(post => post.postNo);
      setCookie(data.key, encodeURIComponent(JSON.stringify({ postNos })), expireDate);
    }
    const { name } = data;
    this.mainModal[name].isClose = true;
  }

  mounted() {
    this.fetchCosSections();
  }
}
